import templateUrl from './views/downloading.tpl.html'


angular
    .module('festzelt-os.downloads', ['ngFileSaver'])
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.download', {
            url: '/download/{type}/{file}',
            controller: 'DownloadsCtrl',
            controllerAs: 'vm',
            data: {
                hideBreadcrumb: true,
                fullWidth: true
            },
            templateUrl,
        })
        .state('app.download-file', {
            url: '/download/{file}?name',
            controller: 'DownloadsCtrl',
            controllerAs: 'vm',
            data: {
                hideBreadcrumb: true,
                fullWidth: true
            },
            templateUrl,
        })
}

// Controllers
require('./controllers/downloads-controller');



// WEBPACK FOOTER //
// ./src/app/pages/downloads/downloads-routes.js